<template>
  <div>
    <el-dialog title="紧急联系人" :visible.sync="dialog" width="840px" >
      <el-form ref="ruleForm" :model="formData" label-width="80px" style="padding:20px 0 0 20px">
        <el-row style="margin-bottom: 10px">
          <el-col :span="10">
            <el-form-item label="姓名" prop="comments">
              <el-input style="width: 210px" v-model="formData.comments" placeholder="请输入" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px">
          <el-col :span="10">
            <el-form-item label="电话" prop="comments">
              <el-input style="width: 210px" v-model="formData.comments" placeholder="请输入" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="关系" prop="comments">
              <el-input style="width: 210px" v-model="formData.comments" placeholder="请输入" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="danger" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UpdateEmergencyContact",
  data() {
    return {
      dialog:false,
      formData:{

      }
    }
  },
  methods: {
    openDialog(item){
      console.log(item)
      this.dialog = true;
    },
    confirm(){

    }
  }
}
</script>

<style scoped>

</style>